export default __webpack_public_path__ + "static/Logo-526c38aeee178c523f290aeea61d660b.png";